export default __webpack_public_path__ + "static/media/logo.d46eea91.png";